import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.checkliste-veranstaltungs-typen-hinzufuegen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenChecklisteVeranstaltungsTypenHinzufuegenEffects {

    ChecklisteVeranstaltungsTypenHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_CHECKLISTE_VERANSTALTUNGS_TYPEN_HINZUFUEGEN),
        mergeMap((x: ac.PostChecklisteVeranstaltungsTypenHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postChecklisteVeranstaltungsTypenHinzufuegen(x.checklisteVeranstaltungsTypMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostChecklisteVeranstaltungsTypenHinzufuegenErfolgreichAction(result, x.checklisteVeranstaltungsTypMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostChecklisteVeranstaltungsTypenHinzufuegenFehlerAction(error, x.checklisteVeranstaltungsTypMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ChecklisteCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ChecklisteCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.ChecklisteCommandService);
        }
        return this.service;
    }
}
